import SuperFetchV2 from '../../superFetchV2';
import {
  DeliveryEnterprisesContractCodeValidationsRequestBodyDto,
  DeliveryEnterprisesContractCodeValidationsResponseBodyDto,
  DeliveryEnterprisesFindAllResponseDto,
} from '../../../types/api/delivery-enterprises';

type DeliveryEnterprisesQueryParams = {
  status: 'inactive' | 'active';
  autoTakebackEnabled: boolean;
};

const deliveryEnterprisesApi = {
  getDeliveryEnterprises: (params: DeliveryEnterprisesQueryParams): Promise<DeliveryEnterprisesFindAllResponseDto> =>
    SuperFetchV2.get('/delivery-enterprises', {
      params,
    }),
  contractCodeValidations: (
    deliveryEnterpriseId: number,
    payload: DeliveryEnterprisesContractCodeValidationsRequestBodyDto,
  ): Promise<DeliveryEnterprisesContractCodeValidationsResponseBodyDto> =>
    SuperFetchV2.post(`/delivery-enterprises/${deliveryEnterpriseId}/contract-code-validations`, payload),
};

export default deliveryEnterprisesApi;
